import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BusinessesforSale.module.css'; // Assuming you create a separate file for CSS

function SuccessMsg() {
  const navigate = useNavigate();

  // Navigate to the businesses page or dashboard
  const handleNavigate = () => {
    navigate("/BusinessesforSale");  // Update this to the actual route for business listings or the relevant page
  };

  return (
    <div className={styles.successMessageContainer}>
        <div className={styles.successMessage}>
            <p>Admin will contact you soon.</p>
            
            {/* Navigation Button */}
            <button className={styles.businessNavButton} onClick={handleNavigate}>
                View Businesses
            </button>
        </div>
    </div>
  )
}

export default SuccessMsg;
